import React, { useState } from "react"
import { Link } from "react-router-dom"
import {
  Facebook,
  Instagram,
  Mail,
  Phone,
  MapPin,
  CreditCard,
  Truck,
  Shield,
  RefreshCw,
} from "lucide-react"
const Logo = "/Logo.png";
import EnquiryModal from "../common/EnquiryModal"

const Footer: React.FC = () => {
  const [showEnquiryModal, setShowEnquiryModal] = useState(false)

  // Categories from navbar
  const categories = [
    { name: "Sofa", slug: "sofas", path: "/categories/sofas" },
    { name: "Dining", slug: "dining", path: "/categories/dining" },
    { name: "Wardrobe", slug: "wardrobes", path: "/categories/wardrobes" },
    { name: "Chair", slug: "chairs", path: "/categories/chairs" },
    { name: "Tables", slug: "tables", path: "/categories/tables" },
    { name: "TV Units", slug: "tv-units", path: "/categories/tv-units" },
    { name: "Modular Kitchen", slug: "modular-kitchen", path: "/categories/modular-kitchen" },
    { name: "Safety Door", slug: "safety-door", path: "/categories/safety-door" },
    { name: "Beds", slug: "beds", path: "/categories/beds" },
    { name: "Mandir", slug: "mandir", path: "/categories/mandir" },
    
  ]

  return (
    <footer className="bg-primary-900 text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <img src={Logo} alt="Anmol Furniture Bazar Logo" className="w-30 h-16 rounded-lg border-2 border-primary-600" />
            </div>
            <p className="text-gray-300 mb-4">
              Your trusted partner for premium furniture. Creating beautiful spaces that inspire and comfort for over a
              decade.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.facebook.com/AnmolFurnitureBazar" 
                className="text-gray-300 hover:text-white transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href="https://www.instagram.com/anmol_furniture_bazar" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-white transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-300 hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/shipping" className="text-gray-300 hover:text-white transition-colors">
                  Shipping Info
                </Link>
              </li>
              <li>
                <Link to="/returns" className="text-gray-300 hover:text-white transition-colors">
                  Returns & Exchanges
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-300 hover:text-white transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <button
                  onClick={() => setShowEnquiryModal(true)}
                  className="text-gray-300 hover:text-white transition-colors text-left"
                >
                  Enquiry
                </button>
              </li>
              <li>
                <Link to="/leads" className="text-gray-300 hover:text-white transition-colors">
                  Leads
                </Link>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Shop by Category</h3>
            <ul className="space-y-2">
              {categories.slice(0, 9).map((category) => (
                <li key={category.slug}>
                  <Link 
                    to={category.path} 
                    className="text-gray-300 hover:text-white transition-colors"
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Get in Touch</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                
                <div>
                 
                  <a
  href="https://maps.google.com/maps?q=Anmol+Furniture+Bazar,+Virar+East,+Thane,+Maharashtra+401305"
  target="_blank"
  rel="noopener noreferrer"
  className="inline-flex items-center space-x-1 text-primary-400 hover:text-primary-300 transition-colors text-sm mt-1"
>
  <MapPin className="w-5 h-5 text-primary-400 mt-0.5 flex-shrink-0" />
  <div>
    <p className="text-gray-300">Anmol Furniture Bazar</p>
    <p className="text-gray-300">Virar East, Thane</p>
    <p className="text-gray-300">Maharashtra 401305</p>
  </div>
</a>

                </div>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-primary-400" />
                <div>
                  <p className="text-gray-300">+91 8010271912</p>
                  <p className="text-gray-300">+91 9987023567</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-primary-400" />
<div>
  <a 
    href="mailto:anmolfurniturebazaar@gmail.com" 
    className="text-gray-300 hover:text-primary-400 transition"
  >
    anmolfurniturebazaar@gmail.com
  </a>
</div>

              </div>
            </div>

            {/* Business Hours */}
            <div className="mt-6">
              <h4 className="font-semibold mb-2 text-primary-200">Business Hours </h4>
              <div className="text-sm text-gray-300 space-y-1">
                <p>Mon - Sat: 9:00 AM - 8:00 PM</p>
                <p>Sunday: 10:00 AM - 6:00 PM</p>
              </div>
            </div>
          </div>
        </div>

        {/* Features Section */}
        <div className="border-t border-primary-800 mt-8 pt-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            <div className="flex items-center space-x-3">
              <Truck className="w-8 h-8 text-primary-400" />
              <div>
                <h4 className="font-semibold text-primary-200">Free Delivery</h4>
                <p className="text-sm text-gray-300">On orders above ₹25,000</p>
              </div>
            </div>

            <div className="flex items-center space-x-3">
              <Shield className="w-8 h-8 text-primary-400" />
              <div>
                <h4 className="font-semibold text-primary-200">Warranty</h4>
                <p className="text-sm text-gray-300">Up to 3 years coverage</p>
              </div>
            </div>

            <div className="flex items-center space-x-3">
              <RefreshCw className="w-8 h-8 text-primary-400" />
              <div>
                <h4 className="font-semibold text-primary-200">Easy Returns</h4>
                <p className="text-sm text-gray-300">30-day return policy</p>
              </div>
            </div>

            <div className="flex items-center space-x-3">
              <CreditCard className="w-8 h-8 text-primary-400" />
              <div>
                <h4 className="font-semibold text-primary-200">Secure Payment</h4>
                <p className="text-sm text-gray-300">Multiple payment options</p>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-primary-800 mt-8 pt-8 text-center text-gray-300">
          <p>&copy; {new Date().getFullYear()} Anmol Furniture Bazar. All rights reserved.</p>
        </div>
      </div>

      {/* Enquiry Modal */}
      <EnquiryModal
        isOpen={showEnquiryModal}
        onClose={() => setShowEnquiryModal(false)}
      />
    </footer>
  )
}

export default Footer
